import DocumentCategory from "./DocumentCategory"
export default DocumentCategory;